import {
  Component,
  computed,
  ElementRef,
  inject,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { HorizontalScrollHelperComponent } from "../../../shared/components/horizontal-scroll-helper/horizontal-scroll-helper";
import { pathRouteDataHelper$ } from "../../../shared/helpers/path-params.helper";
import { ProductsComparisonsSelects } from "../products-comparisons-selects/products-comparisons-selects";

@Component({
  selector: "claas-products-compare-tech-data",
  imports: [ProductsComparisonsSelects, HorizontalScrollHelperComponent],
  templateUrl: "./products-compare-tech-data.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./products-compare-tech-data.scss",
})
export class ProductsCompareTechData {
  route = inject(ActivatedRoute);

  @ViewChild("scrollContainer", { static: false })
  scrollContainer!: ElementRef<HTMLDivElement>;

  data = toSignal(pathRouteDataHelper$());
  techData = computed(() => this.data()?.["techDataComparison"]);
}
